import React from "react";
import { useSelector } from "react-redux";

function StoryItem({ story }) {
  const dictionary = useSelector((state) => state.localization.dictionary);

  function getSrcSet(url) {
    let index = url.indexOf("?");

    // No query string
    if (index === -1) {
      return url;
    }

    let path = url.substring(0, index);

    return `${path}?width=370 370w, ${path}?width=768 768w, ${path}?width=420 420w`;
  }

  function getMeta() {
    if (
      (story.city && story.city !== "") ||
      (story.province && story?.province !== "")
    ) {
      return (
        <span className="type">
          {story.city}
          {story.city && story.city !== "" ? ", " : ""}
          {story.province}
        </span>
      );
    }
  }

  return (
    <div className="clearfix story list-item">
      <div className="columns medium-4 small-12 thumb">
        {story?.sponsored ? (
          <div className="sponsored">{dictionary["CNHS.global.sponsored"]}</div>
        ) : null}
        <a
          href={story.url}
          aria-hidden="true"
          role="presentation"
          tabIndex="-1"
        >
          <img
            src={story.thumbnail}
            alt={story.thumbnailAlt}
            srcSet={getSrcSet(story.thumbnail)}
            sizes="(min-width: 768px) 370px, (max-width: 768px) 768px, (max-width: 420px) 420px, 768px"
          />
        </a>
      </div>
      <div className="columns medium-8 content small-12">
        <h2>
          <a href={story.url}>{story.title}</a>
        </h2>
        <div
          className="teaser"
          dangerouslySetInnerHTML={{
            __html: story.teaser,
          }}
        ></div>
        <div className="meta">
          {getMeta()}
          {story.format && story.format !== "" ? (
            <span className="type">{story.format} / </span>
          ) : null}

          <span className="date">{story.releaseDate}</span>
        </div>
        {story.gradeLevels ? (
          <div className="grade-level">
            {dictionary["CNHS.CustomTable.CNHS.GradeLevel"]}:{" "}
            {story.gradeLevels.join(", ")}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default StoryItem;
